module.exports = __webpack_public_path__ + "img/banner2.90f16fbd.png";